/**
 * @file    AboutPage.css - Style for the about page.
 * @author  Jordan Cartlidge <jordan@kingsds.network>
 * @author  Kevin Yu <kevin@distributive.network>
 * @author  Ryan Saweczko <ryansaweczko@distributive.network>
 * @date    July 2022, Oct 2025
 */


#aboutPage .portal-title h1 {
  font-size: 1.5rem;
}

#aboutPage section {
  padding: 40px 60px 40px 80px;
  color: black;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  gap: 15px;
}

#aboutPage section p {
  font-size: 0.875rem;
  line-height: 20.47px;
  padding: 0;
}

#aboutPage section a {
  text-decoration: underline;
  color: inherit
}

.about-header {
  padding: 0 30px;
  min-height: 80px;
  background: var(--about-modal-header);
  display: flex;
  align-items: center;
}

.about-banner-logo {
  height: 50px;
  width: auto;
}

.branded-content hr {
  height: 1px;
  width: 100%;
  background-color: var(--content-hue-light);
  margin: 25px 0;
}

.about-powered-by-title {
  margin: 0 0 5px 0;
}

.about-powered-by {
  position: absolute;
  bottom: 40px;
  right: 60px;
}

#aboutPage p {
  padding: .7em 0;
}

@media only screen and (max-width: 500px) {
  #aboutPage img {
    max-width: 250px;
  }

  #aboutPage section {
    padding: 40px 0 0;
  }
}
